import { Statuses } from "./rating/enums";
var CollectionRating = (function () {
    function CollectionRating() {
        this.id = 0;
        this.note = 0;
        this.comment = '';
        this.collectionSlug = '';
        this.userUuid = '';
        this.userName = '';
        this.postedAt = new Date();
        this.status = Statuses.Enabled;
    }
    CollectionRating.createFromApi = function (data) {
        var rating = new CollectionRating();
        rating.id = data === null || data === void 0 ? void 0 : data.id;
        rating.note = data === null || data === void 0 ? void 0 : data.note;
        rating.comment = data === null || data === void 0 ? void 0 : data.comment;
        rating.collectionSlug = data === null || data === void 0 ? void 0 : data.collection_slug;
        rating.userUuid = data === null || data === void 0 ? void 0 : data.user_uuid;
        rating.userName = data === null || data === void 0 ? void 0 : data.user_name;
        rating.postedAt = data === null || data === void 0 ? void 0 : data.posted_at;
        rating.status = data === null || data === void 0 ? void 0 : data.status;
        return rating;
    };
    return CollectionRating;
}());
export { CollectionRating };
